import {endpoints} from './endpoints'
import request from '../request'

export function getClientCRM (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getClientCRM,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getClientPreProjects (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getClientPreProjects,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getClientContracts (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getClientContracts,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getClientBudgets (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getClientBudgets,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getClientReports (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getClientReports,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getClientRequests (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getClientRequests,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}